/** Label-over-value cell used by the region profile's read grid. */
export function RegionReadRow({ label, value }: { label: string; value: string | number }) {
  return (
    <div>
      <div className="nb-eyebrow" style={{ fontSize: 9, marginBottom: 2 }}>
        {label}
      </div>
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--nb-ink)' }}>{value}</div>
    </div>
  );
}
